import { Theme } from '@mui/material/styles'

export const getSXStyles = (isMobile: boolean) => ({
  centered: {
    alignItems: 'center',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: (theme: Theme) => theme.spacing(0.2),
    width: '100%',
  },

  container: {},

  title: {
    width: '100%',
  },

  main: {
    alignContent: 'center',
    display: 'inline-flex',
    flexDirection: 'row',
  },

  scroll: {
    display: 'flex',
    maxWidth: isMobile ? '470px' : '660px',
    marginRight: isMobile ? '0' : 2,
  },

  sticky: {
    display: 'flex',
    height: '300px',
    position: 'sticky',
    top: '150px',
    width: '300px',
  },
})
